import { formatCurrency, getCurrencySymbol } from '@/common/utils/formatCurrency';
import { EmptyFieldValue } from '@/features/items/components/item-field-value/EmptyFieldValue';
import { Field } from '@/features/items/components/item-field-value/Field';
import { NumericField } from './NumericField';

export const CurrencyField = ({
  id,
  name,
  value,
  currencyUnit,
  isEditable = false,
  onChange,
  isPending,
  isSuccess,
  isError,
  error,
  autoFocus = false,
  allowClear = false,
}: {
  id: string;
  name: string;
  value?: number;
  currencyUnit: string | null;
  isEditable?: boolean;
  onChange?: (value: number | undefined) => void;
  isPending?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  error?: Error | null;
  autoFocus?: boolean;
  allowClear?: boolean;
}) => {
  const inputId = `currency-field-${id}`;
  const currencySymbol = getCurrencySymbol(currencyUnit);

  if (!isEditable) {
    return (
      <Field inputId={inputId} name={name}>
        <div className="text-sm text-text-neutral-primary" data-testid="currency-field-value">
          {value === undefined ? <EmptyFieldValue /> : formatCurrency(value ?? 0, currencyUnit)}
        </div>
      </Field>
    );
  }

  return (
    <NumericField
      id={id}
      name={name}
      value={value}
      isEditable={isEditable}
      onChange={onChange}
      isPending={isPending}
      isSuccess={isSuccess}
      isError={isError}
      error={error}
      prefix={currencySymbol}
      autoFocus={autoFocus}
      allowClear={allowClear}
    />
  );
};
